import { setupKeyboardScrollIndicators } from "./organ/scrollIndicators";
import { createPipeId, leadingZero } from "./helpers";
import { setupSponsoringButtons  } from "./popup";

const PEDALS_ID = "pedale";
const LOWER_MANUAL_ID = "hauptwerk";
const UPPER_MANUAL_ID = "schwellwerk";

const activeRegisters = {
    [PEDALS_ID]: 0,
    [LOWER_MANUAL_ID]: 0,
    [UPPER_MANUAL_ID]: 0,
};

// TODO: abort controller for availability requests?
let abortController = null;

function getSoundFileRegisterName(groupName) {
    const activeRegisterIndex = activeRegisters[groupName];

    switch (groupName) {
        case PEDALS_ID:
            return [
                "01_subbass16",
                "02_oktavbass8",
                "03_gedackt8",
                "04_choralbass4",
                "05_bassfloete4",
                "06_basstrompete",
            ][activeRegisterIndex];
        case LOWER_MANUAL_ID:
            return [
                "09_pommer16",
                "10_prinzpal8",
                "11_gemshorn8",
                "12_prinzipal4",
                "13_floete2",
                "14_siffloete1",
                "15_mixtur",
                "16_trompete8",
            ][activeRegisterIndex];
        case UPPER_MANUAL_ID:
            return [
                "18_gedackt8",
                "19_blockfloete4",
                "20_praestant2",
                "21_sesquiaaltera",
                "22_cimbel",
            ][activeRegisterIndex];
        default:
            return undefined;
    }
}

function getKeySoundFilePath(groupName, keyNumber) {
    const soundFileRegisterName = getSoundFileRegisterName(groupName);

    if (soundFileRegisterName === undefined) {
        return console.error(
            `cannot find pipe sound for ${groupName} - ${keyNumber}`
        );
    }

    const offset = 35;
    const note = offset + keyNumber;

    return `/sounds/${soundFileRegisterName}/channel1-note${note}-velocity127-1.mp3`;
}

function playKeySound(groupName, keyNumber) {
    const a = new Audio(getKeySoundFilePath(groupName, keyNumber));
    a.play().catch(console.warn);
}

function handlePipePlayed(groupName, keyNumber) {
    const registerNumber = activeRegisters[groupName] + 1;
    const pipeId = createPipeId(registerNumber, groupName, keyNumber);

    if (abortController) {
        abortController.abort();
    }

    abortController = new AbortController();

    Promise.all([
        fetch(`/ajax/sponsor/${pipeId}`, {
            signal: abortController.signal,
        }).then((r) => r.text()),
        fetch(`/ajax/repeated-sponsor/${pipeId}`, {
            signal: abortController.signal,
        }).then((r) => r.text()),
    ])
        .then(([sponsorHtml, repeatSponsorHtml]) => {
            history.pushState({}, "", `/orgel/${pipeId}`);

            document.getElementById("sponsoring-container").innerHTML =
                sponsorHtml;
            document.getElementById(
                "repeated-sponsoring-button-container"
            ).innerHTML = repeatSponsorHtml;
            setupSponsoringButtons();
        })
        .catch(console.warn);

    playKeySound(groupName, keyNumber);
}

function setupManualKeys(groupName) {
    const keys = document.querySelectorAll(`#${groupName} .key`);

    keys.forEach((k) =>
        k.addEventListener("click", () => {
            const keyNumber = parseInt(k.getAttribute("tabindex"));
            handlePipePlayed(groupName, keyNumber);
        })
    );
}

function updateKeyAvailability(groupName, registerIndex) {
    const keysAndPedals = document.querySelectorAll(
        `#${groupName} .key, #${groupName} .pedal`
    );

    keysAndPedals.forEach((el) => {
        const sponsoringEl = el.querySelector(".sponsoring-available");
        if (sponsoringEl) {
            sponsoringEl.remove();
        }
    });

    fetch(
        `/ajax/available-sponsorings/${groupName}-${leadingZero(
            registerIndex + 1
        )}`
    )
        .then((response) => response.json())
        .then((data) => {
            keysAndPedals.forEach((key) => {
                if (!data[key.getAttribute("tabindex")]) {
                    const el = document.createElement("span");
                    el.classList.add("sponsoring-available");
                    key.firstElementChild.appendChild(el);
                }
            });
        })
        .catch(console.error);
}

function selectRegister(el, groupName, registerIndex, selector) {
    if (!el.classList.contains("enabled")) {
        const oldEnabled = document.querySelector(`${selector}.enabled`);

        if (oldEnabled) {
            oldEnabled.classList.remove("enabled");
        }

        el.classList.add("enabled");
        activeRegisters[groupName] = registerIndex;
    }
}

function setupRegisterGroup(groupName) {
    const selector = `#for-${groupName} .register`;

    const registers = document.querySelectorAll(selector);

    registers.forEach((r, i) =>
        r.addEventListener("click", () => {
            selectRegister(r, groupName, i, selector);
            updateKeyAvailability(groupName, i);
        })
    );
}

function setupPedals() {
    const pedals = document.querySelectorAll(`#${PEDALS_ID} .pedal`);

    pedals.forEach((p) =>
        p.addEventListener("click", () => {
            const pedalNumber = parseInt(p.getAttribute("tabindex"));

            handlePipePlayed(PEDALS_ID, pedalNumber);
        })
    );
}

function setupManuals() {
    setupManualKeys(LOWER_MANUAL_ID);
    setupManualKeys(UPPER_MANUAL_ID);
}

function setupRegisters() {
    setupRegisterGroup(PEDALS_ID);
    setupRegisterGroup(LOWER_MANUAL_ID);
    setupRegisterGroup(UPPER_MANUAL_ID);
}

function main() {
    setupRegisters();
    setupManuals();
    setupPedals();
    setupKeyboardScrollIndicators();
    setupSponsoringButtons();
}

window.addEventListener("load", main);
